module.exports = __webpack_public_path__ + "img/will-robinson-old-mage.d51dd54.jpg";